import createAPI from '../axios'

// 选修管理相关API
const electiveManageAdultEducation = {
    classSetting: {
        list: config => createAPI('/classSettingAdultEducation/list', 'post', config),
        initOption: config => createAPI('/classSettingAdultEducation/initOption', 'post', config),
        deptOption: config => createAPI('/classSettingAdultEducation/deptOption', 'post', config),
        majorOption: config => createAPI('/classSettingAdultEducation/majorOption', 'post', config),
        classOption: config => createAPI('/classSettingAdultEducation/classOption', 'post', config),
        queryElectiveTime: config => createAPI('/classSettingAdultEducation/queryElectiveTime', 'post', config),
        saveElectiveTime: config => createAPI('/classSettingAdultEducation/saveElectiveTime', 'post', config),
        initCredit: config => createAPI('/classSettingAdultEducation/initCredit', 'post', config),
        queryCredit: config => createAPI('/classSettingAdultEducation/queryCredit', 'post', config),
        saveCreditSet: config => createAPI('/classSettingAdultEducation/saveCreditSet', 'post', config),
        getWeeknum: config => createAPI('/classSettingAdultEducation/getWeeknum', 'post', config),
        courseOption: config => createAPI('/classSettingAdultEducation/courseOption', 'post', config),
        classTimeOption: config => createAPI('/classSettingAdultEducation/classTimeOption', 'post', config),
        queryTeacher: config => createAPI('/classSettingAdultEducation/queryTeacher', 'post', config),
        querySite: config => createAPI('/classSettingAdultEducation/querySite', 'post', config),
        saveElective: config => createAPI('/classSettingAdultEducation/saveElective', 'post', config),
        delElective: config => createAPI('/classSettingAdultEducation/delElective', 'post', config),
        timeslotOption: config => createAPI('/classSettingAdultEducation/timeslotOption', 'post', config),
        relatedCourseOption: config => createAPI('/classSettingAdultEducation/relatedCourseOption', 'post', config),
        courseTypeOption: config => createAPI('/classSettingAdultEducation/courseTypeOption', 'post', config),
    },
    studentSelection: {
        list: config => createAPI('/studentSelectionAdultEducation/list', 'post', config),
        initOption: config => createAPI('/studentSelectionAdultEducation/initOption', 'post', config),
        checkSelectTime: config => createAPI('/studentSelectionAdultEducation/checkSelectTime', 'post', config),
        studentSelection: config => createAPI('/studentSelectionAdultEducation/studentSelection', 'post', config),
        queryStuSelection: config => createAPI('/studentSelectionAdultEducation/queryStuSelection', 'post', config),
        delSelection: config => createAPI('/studentSelectionAdultEducation/delSelection', 'post', config),
    },
    electiveManage: {
        list: config => createAPI('/electiveManageAdultEducation/list', 'post', config),
        initOption: config => createAPI('/electiveManageAdultEducation/initOption', 'post', config),
        queryElectiveClassStu: config => createAPI('/electiveManageAdultEducation/queryElectiveClassStu', 'post', config),
        queryStudent: config => createAPI('/electiveManageAdultEducation/queryStudent', 'post', config),
        saveElectiveStu: config => createAPI('/electiveManageAdultEducation/saveElectiveStu', 'post', config),
        queryChangeClassList: config => createAPI('/electiveManageAdultEducation/queryChangeClassList', 'post', config),
        changeElectiveStu: config => createAPI('/electiveManageAdultEducation/changeElectiveStu', 'post', config),
        delElectiveStu: config => createAPI('/electiveManageAdultEducation/delElectiveStu', 'post', config),
        exportCourse: config => createAPI('/electiveManageAdultEducation/exportCourse', 'post', config),
        exportStudent: config => createAPI('/electiveManageAdultEducation/exportStudent', 'post', config),
        queryInsufficientCredit: config => createAPI('/electiveManageAdultEducation/queryInsufficientCredit', 'post', config),
        queryStuCredit: config => createAPI('/electiveManageAdultEducation/queryStuCredit', 'post', config),
        exportCredit: config => createAPI('/electiveManageAdultEducation/exportCredit', 'post', config),
        importElectiveScore: config => createAPI('/electiveManageAdultEducation/importElectiveScore', 'post', config),
        queryNoChooseXXK: config => createAPI('/electiveManageAdultEducation/queryNoChooseXXK', 'post', config),
        exportNochoose: config => createAPI('/electiveManageAdultEducation/exportNochoose', 'post', config),
    },
    electiveInfo: {
        list: config => createAPI('/electiveInfoAdultEducation/list', 'post', config),
        initOption: config => createAPI('/electiveInfoAdultEducation/initOption', 'post', config),
        deptOption: config => createAPI('/electiveInfoAdultEducation/deptOption', 'post', config),
        majorOption: config => createAPI('/electiveInfoAdultEducation/majorOption', 'post', config),
        classOption: config => createAPI('/electiveInfoAdultEducation/classOption', 'post', config),
        exportStuSelection: config => createAPI('/electiveInfoAdultEducation/exportStuSelection', 'post', config),
    }
};

export default electiveManageAdultEducation;



// WEBPACK FOOTER //
// ./src/api/modules/electiveManageAdultEducation.js